'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var lingojsCore = require('@bookingcom/lingojs-core');
var constants = require('./constants.js');
var utils = require('./utils.js');

/**
 * Parses time string
 */
function getTimeParts(time) {
    var date = utils.isValidDate(time) ? time : new Date("2019-01-01T".concat(time));
    if (utils.isValidDate(date)) {
        var _a = utils.getDateParts(date), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
        return {
            hour: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    throw new Error("formatting/time: invalid time provided \u2014 ".concat(time));
}
function timeVariations(timeParts, until) {
    var hour_24h_show24_no0 = timeParts.hour == 0 && timeParts.minutes == 0 ? 24 : timeParts.hour;
    var hour_24h_until24_no0 = until ? hour_24h_show24_no0 : timeParts.hour;
    var hour_12h_no0 = timeParts.hour === 0 || timeParts.hour === 12 ? 12 : timeParts.hour % 12;
    return utils.toStringHash({
        hour_24h_no0: timeParts.hour,
        hour_24h: utils.leftPad(timeParts.hour),
        hour_24h_show24: utils.leftPad(hour_24h_show24_no0),
        hour_24h_until24: utils.leftPad(hour_24h_until24_no0),
        hour_12h: utils.leftPad(hour_12h_no0),
        minutes: utils.leftPad(timeParts.minutes),
        hour_12h_no0: hour_12h_no0,
        hour_24h_show24_no0: hour_24h_show24_no0,
        hour_24h_until24_no0: hour_24h_until24_no0
    });
}
function formatTime(i18n, options) {
    var _a;
    if (!i18n) {
        throw new Error('No i18n object provided');
    }
    var item = constants.TimeFormatItem.time;
    if ('12_hour' == options.format) {
        item = constants.TimeFormatItem.time_12;
    }
    else if ('24_hour' == options.format) {
        item = constants.TimeFormatItem.time_24;
    }
    var timeParts = getTimeParts(options.time);
    var symbol = "".concat(timeParts.hour < 12 ? 'AM' : 'PM', "_symbol");
    var parts = tslib.__assign({ AM_PM: i18n.trans(lingojsCore.t('time_format', symbol, 'name', { variables: {} })) }, timeVariations(timeParts, (_a = options.until) !== null && _a !== void 0 ? _a : false));
    return i18n.trans(lingojsCore.t('time_format', item, 'name', { variables: parts })).trim();
}

exports.formatTime = formatTime;
//# sourceMappingURL=format-time.js.map
